import apiClient from "./axios"

// Get all customer areas with optional filtering
export const getCustomerAreas = async (params = {}) => {
  const { data } = await apiClient.get("/customer-areas", { params })
  return data
}

// Get a specific customer area by ID
export const getCustomerArea = async id => {
  const { data } = await apiClient.get(`/customer-areas/${id}`)
  return data
}

// Create a new customer area
export const createCustomerArea = async areaData => {
  const { data } = await apiClient.post("/customer-areas", areaData)
  return data
}

// Update an existing customer area
export const editCustomerArea = async ({ id, ...areaData }) => {
  const { data } = await apiClient.patch(`/customer-areas/${id}`, areaData)
  return data
}

// Delete a customer area (soft delete)
export const deleteCustomerArea = async id => {
  const { data } = await apiClient.delete(`/customer-areas/${id}`)
  return data
}

// Get all customer areas without pagination
export const getAllCustomerAreas = async (params = {}) => {
  const { data } = await apiClient.get("/customer-areas", {
    params: { ...params, all: true },
  })
  return data
}

// Search customer areas by name or slug
export const searchCustomerAreas = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/customer-areas", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed customer areas
export const getTrashedCustomerAreas = async (params = {}) => {
  const { data } = await apiClient.get("/customer-areas/trashed", { params })
  return data
}

// Get a customer area by slug
export const getCustomerAreaBySlug = async slug => {
  const { data } = await apiClient.get(`/customer-areas/slug/${slug}`)
  return data
}

// Restore a trashed customer area
export const restoreCustomerArea = async id => {
  const { data } = await apiClient.post(`/customer-areas/${id}/restore`)
  return data
}
